import { ChildComponents } from '../../DnDChildComponents';
import { HeartLight, Plus, Percentage } from '../../../../../../../assets/svgs';
import { useSelector } from 'react-redux';

function Product_2({ customization, imgObj, productWidth, iconFilters }) {
  const imageHashMap = useSelector(state => state.themeSlice?.imageHashMap);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const star = (
    <svg
      style={{ width: customization?.starSize, height: customization?.starSize }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4446 5.9416C15.3776 5.72283 15.2484 5.53019 15.0739 5.38891C14.8995 5.24764 14.688 5.16434 14.4672 5.14993L10.4905 4.86521L9.01761 1.01104C8.93718 0.798821 8.7972 0.616529 8.61577 0.487766C8.43434 0.359002 8.21983 0.289695 8 0.288818C7.78017 0.289695 7.56566 0.359002 7.38423 0.487766C7.20281 0.616529 7.06282 0.798821 6.98239 1.01104L5.48277 4.88604L1.53285 5.14993C1.31226 5.16527 1.10118 5.24893 0.926928 5.39006C0.752672 5.5312 0.623253 5.72333 0.555413 5.9416C0.485747 6.16321 0.481677 6.40139 0.543727 6.62542C0.605776 6.84946 0.731101 7.04908 0.903541 7.19854L3.94297 9.86521L3.03917 13.5527C2.97664 13.8022 2.9879 14.0654 3.07147 14.3081C3.15505 14.5508 3.30708 14.7619 3.50781 14.9138C3.70265 15.0589 3.93478 15.1403 4.1745 15.1477C4.41422 15.1552 4.65062 15.0882 4.85346 14.9555L7.99331 12.893H8.0067L11.3876 15.1083C11.561 15.2252 11.7632 15.2878 11.97 15.2888C12.1389 15.2874 12.3052 15.2459 12.4562 15.1674C12.6072 15.089 12.7388 14.9756 12.841 14.8361C12.9431 14.6966 13.0131 14.5347 13.0455 14.3628C13.0778 14.1908 13.0718 14.0135 13.0278 13.8444L12.0704 9.80965L15.0965 7.19854C15.2689 7.04908 15.3942 6.84946 15.4563 6.62542C15.5183 6.40139 15.5143 6.16321 15.4446 5.9416Z"
        fill="#E5E5E5"
      ></path>
    </svg>
  );

  const productDiscountPriceTextSize = customization?.productDiscountPriceTextSize?.replace('px', '');
  const productPriceTextSize = customization?.productPriceTextSize?.replace('px', '');
  return (
    <div style={{ padding: customization?.padding, width: productWidth + '%' }}>
      <div
        className="height-auto-info border-box-new relative overflow-hidden  h-full flex flex-col "
        style={{
          borderWidth: 1,
          borderColor: customization?.borderColor,
          borderRadius: customization?.borderRadius,
          padding: customization?.betweenProductAndBorderPadding,
          boxShadow: ChildComponents[customization?.boxShadow]?.data,
        }}
      >
        <div
          className="shrink-0 relative"
          style={{
            height: customization?.productImageHeight,
            padding: customization?.productImagePadding,
            backgroundColor:
              customization?.productBackgroundType === 'productBackgroundColor'
                ? customization?.productBackgroundColor
                : '',
            backgroundImage:
              customization?.productBackgroundType === 'productBackgroundImage'
                ? `url(${customization?.productBackgroundImage})`
                : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          {imgObj?.image?.type === "video" ?
            <video
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
              autoPlay muted playsInline loop src={imgObj?.image?.src}

            ></video> :
            <img
              loading="lazy"
              src={imgObj?.useCustomImage ? imgObj?.image?.src : imageHashMap[imgObj?.id]?.image}
              className="widgets-ratio-1 h-full w-full"
              alt=""
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
            />
          }
          <div className="absolute p-[6%] right-0 top-0 justify-end flex flex-row w-full">
            {customization?.isHeartIcon && (
              <div
                className="heart-fill-icon bdr-raduis-eight 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px]  right-0"
                style={{
                  backgroundColor: customization?.heartIconBackgroundColor,
                  borderRadius: customization?.heartIconBorderRadius,
                }}
              >
                <img
                  className="shrink-0"
                  src={customization?.heartIcon}
                  alt=""
                  style={{ filter: iconFilters.heartIconFilter, width: customization?.heartIconWidth }}
                />
              </div>
            )}
          </div>
          <div className="absolute p-[6%] right-0 bottom-0 justify-end flex flex-row w-full">
            {customization?.isCartIcon && (
              <div
                className="heart-fill-icon bdr-raduis-eight 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px]  right-0"
                style={{
                  backgroundColor: customization?.cartIconBackgroundColor,
                  color: customization?.cartIconColor,
                  borderRadius: customization?.cartIconBorderRadius,
                }}
              >
                <img
                  src={customization?.cartIcon}
                  alt=""
                  style={{ filter: iconFilters.cartIconFilter, width: customization?.cartIconWidth }}
                />
              </div>
            )}
          </div>
        </div>
        <div
          className="flex flex-row border-t-2 h-full"
          style={{
            borderColor: customization?.productBorderColor,
            backgroundColor: customization?.productDetailBackgroundColor,
          }}
        >
          <div className="w-full flex flex-row   pr-1 pl-1 d-flex justify-between" style={{ padding: 10 }}>
            <div
              className="  shrink-1 flex items-start flex-col overflow-hidden "
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
            >
              <div
                className={`${customization?.productTextControl === 'clip'
                  ? 'truncate'
                  : customization?.productTextControl === 'double'
                    ? 'line-clamp-2'
                    : 'line-clamp-3'
                  } w-full text-left`}
                style={{
                  height: customization?.dynamicHeight
                    ? customization?.productTextControl === 'clip'
                      ? customization?.productTextSize?.replace('px', '') + 'px'
                      : customization?.productTextControl === 'double'
                        ? customization?.productTextSize?.replace('px', '') * 2 + 'px'
                        : customization?.productTextSize?.replace('px', '') * 3 + 'px'
                    : 'auto',
                  color: customization?.productTextColor,
                  fontSize: customization?.productTextSize,
                  lineHeight: customization?.productTextSize,
                  fontWeight: customization?.productTextWeight,
                  textAlign: customization?.productTextAlignment,
                  marginBottom: customization?.productTitleMarginBottom,
                }}
              >
                {imgObj?.image?.text}
              </div>
              {customization?.isShowStar === 'show' && (
                <div class="flex items-center  text-xs md:text-sm leading-none gap-[2%] mt-auto" style={{}}>
                  {star}
                  {star}
                  {star}
                  {star}
                  {star}
                  <span class="!leading-none 2xl:text-[10px] text-[7.97341324459px]">(0)</span>
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: customization?.productPriceTextAlign,
                  width: '100%',
                  alignItems: 'center',
                }}
                className="  shrink-0 mt-1 "
              >
                <div
                  className={` mr-[3px] mt-auto 2xl:mr-[3.76250409702px]  line-through text-left`}
                  style={{
                    fontSize:
                      customization?.productPriceTextAlign === 'row'
                        ? productDiscountPriceTextSize > staticValues[9]
                          ? staticValues[9] + 'px'
                          : productDiscountPriceTextSize + 'px'
                        : productDiscountPriceTextSize + 'px',
                    color: customization?.productDiscountPriceColor,
                    fontWeight: customization?.productDiscountPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
                <div
                  className="text-bold  text-left"
                  style={{
                    fontSize:
                      customization?.productPriceTextAlign === 'row'
                        ? productPriceTextSize > staticValues[9]
                          ? staticValues[9] + 'px'
                          : productPriceTextSize + 'px'
                        : productPriceTextSize + 'px',
                    color: customization?.productPriceColor,
                    fontWeight: customization?.productPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
              </div>
            </div>
          </div>
        </div>
        {customization?.isDiscountIcon && (
          <div className=" flex flex-row font-black	w-full">
            <div
              className="w-full  text-[11.1627785424px] 2xl:text-[14px] leading-[12.7574611913px] 2xl:leading-[16px] 	text-white  p-[5px] 2xl:p-[6.2708401617px]  flex flex-row justify-start items-center  text-center justify-center"
              style={{
                backgroundColor: customization?.discountIconBackgroundColor,
                color: customization?.discountIconColor,
                fontSize: customization?.discountIconWidth,
                borderRadius: customization?.discountIconBorderRadius,
                lineHeight: '130%',
              }}
            >
              % 10 {customization?.discountText}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Product_2;
